import { render } from "./MultiStepsProgress.vue?vue&type=template&id=28c8cc30&scoped=true"
import script from "./MultiStepsProgress.vue?vue&type=script&lang=js"
export * from "./MultiStepsProgress.vue?vue&type=script&lang=js"

import "./MultiStepsProgress.vue?vue&type=style&index=0&id=28c8cc30&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c8cc30"]])

export default __exports__